// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { Form1TravelLeisureComponent } from './travel-leisure-component/form1-travel-leisure.component';


@NgModule({
  // Declarate the needed components
  declarations: [
    Form1TravelLeisureComponent
  ],
  // Import modules which will be used in this module
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule
  ],
  // Indicate the modules which will be used in other modules
  exports: [
    Form1TravelLeisureComponent
  ]
})
export class Form1Module { }
